export default "__VITE_ASSET__718f6673__"